import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const getToastId = (message) => {
  return `toast-${message}`;
};

const showToast = {
  success: (message) => {
    const toastId = getToastId(message);
    toast.success(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: toastId,
    });
  },
  error: (message) => {
    const toastId = getToastId(message);
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: toastId,
    });
  },
  warning: (message) => {
    const toastId = getToastId(message);
    toast.warn(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: toastId,
    });
  },
  info: (message) => {
    const toastId = getToastId(message);
    toast.info(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: toastId,
    });
  },
};

export default showToast;
